/** Valor de fecha que puede venir de Firestore (Timestamp) o ser Date. */
export type FirestoreDate = Date | { toDate(): Date } | { seconds: number };

/** Cliente: puede estar anidado en customerInfo o en la raíz del documento. */
export interface FinancingCustomerInfo {
  firstName?: string;
  lastName?: string;
  cedula?: string;
  phone?: string;
  email?: string;
  address?: string;
  city?: string;
  employmentStatus?: string;
  monthlyIncome?: number;
  workplace?: string;
}

/**
 * Solicitud de financiamiento tal como viene de Firestore (financingRequests).
 * La app móvil puede guardar con customerInfo anidado o con campos planos.
 */
export interface FinancingRequestDoc {
  id: string;
  userId?: string;
  isUserRegistered?: boolean;
  /** Cliente anidado (formulario completo en app). */
  customerInfo?: FinancingCustomerInfo;
  /** Campos planos (alternativa usada en algunos flujos). */
  firstName?: string;
  lastName?: string;
  cedula?: string;
  phone?: string;
  email?: string;
  address?: string;
  city?: string;
  /** Vehículo */
  vehicleId: string;
  vehicleName?: string;
  vehiclePrice?: number;
  vehicleBrand?: string;
  vehicleModel?: string;
  vehicleYear?: number;
  vehicleImage?: string;
  /** Monto: la app puede guardar requestedAmount o loanAmount */
  requestedAmount?: number;
  loanAmount?: number;
  downPayment: number;
  termMonths: number;
  estimatedMonthlyPayment?: number;
  status: string;
  requestMethod?: "quick_contact" | "full_application";
  customerNotes?: string;
  adminNotes?: string;
  rejectionReason?: string;
  assignedTo?: string;
  followUpDate?: FirestoreDate;
  documentsSubmitted?: Record<string, boolean>;
  approvedBy?: string;
  approvedAmount?: number;
  approvedTerms?: unknown;
  createdAt: FirestoreDate;
  updatedAt?: FirestoreDate;
  reviewedAt?: FirestoreDate;
  approvedAt?: FirestoreDate;
  completedAt?: FirestoreDate;
  source?: "mobile_app" | "web" | "admin_panel";
  deviceInfo?: { platform?: string; version?: string; ip?: string };
}

/** Estados conocidos para etiquetas en la UI. */
export const FINANCING_STATUS_LABELS: Record<string, string> = {
  pendiente: "Pendiente",
  en_revision: "En revisión",
  pre_aprobado: "Pre-aprobado",
  aprobado: "Aprobado",
  rechazado: "Rechazado",
  completado: "Completado",
  cancelado: "Cancelado",
};

export const FINANCING_SOURCE_LABELS: Record<string, string> = {
  mobile_app: "App móvil",
  web: "Web",
  admin_panel: "Panel admin",
};
